const MoreOptionsIcon = ({ ...props }) => {
  const { color = 'var(--pcm-body-color-secondary)' } = props;
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_1501_1911)'>
        <circle opacity='0.01' cx='9' cy='9' r='9' transform='rotate(-90 9 9)' fill='#8B8EA1' />
        <circle cx='9' cy='5' r='1' fill={color} />
        <circle cx='9' cy='9' r='1' fill={color} />
        <circle cx='9' cy='13' r='1' fill={color} />
      </g>
      <defs>
        <clipPath id='clip0_1501_1911'>
          <rect width='18' height='18' fill='white' transform='matrix(0 -1 1 0 0 18)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MoreOptionsIcon;
